module.exports = __webpack_public_path__ + "img/snapchat-icon.e04520eb.svg";